// extracted by mini-css-extract-plugin
module.exports = {"docCode":"AppResetPasswordModal_docCode_3YDaL","docCodeInner":"AppResetPasswordModal_docCodeInner_1Or7e"};